(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-two-line-bracket]';

    const init = (header) => {
      if (!(header instanceof HTMLElement) || header.dataset.twoLineBracketStandalone === 'true') return;
      if (!header.querySelector(selector)) return;

      header.dataset.twoLineBracketStandalone = 'true';

      const desktopQuery = window.matchMedia('(min-width: 750px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      let rafId = null;

      const animatePath = (path, nextD) => {
        const previousD = path.getAttribute('d');

        if (!previousD || reducedMotionQuery.matches) {
          path.setAttribute('d', nextD);
          return;
        }

        path.setAttribute('d', nextD);

        const animation = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
        animation.setAttribute('attributeName', 'd');
        animation.setAttribute('from', previousD);
        animation.setAttribute('to', nextD);
        animation.setAttribute('dur', '220ms');
        animation.setAttribute('fill', 'freeze');
        animation.setAttribute('calcMode', 'spline');
        animation.setAttribute('keySplines', '0.2 0.8 0.2 1');

        path.append(animation);
        animation.beginElement();

        window.setTimeout(() => {
          path.setAttribute('d', nextD);
          animation.remove();
        }, 240);
      };

      const hideBracket = () => {
        delete header.dataset.twoLineBracketReady;
      };

      const scheduleUpdate = () => {
        delete header.dataset.twoLineBracketTarget;
        if (rafId !== null) return;

        rafId = window.setTimeout(updateBracket, 16);
      };

      const getActiveHandle = () => {
        const activeParent = header.querySelector(
          '.header-menu--two-line [data-two-line-parent].two-line-menu__link--active'
        );

        return activeParent instanceof HTMLElement ? activeParent.dataset.twoLineParent || '' : '';
      };

      const queryByHandle = (scope, attribute, handle) => {
        if (!handle || !window.CSS?.escape) return null;

        return scope.querySelector(`[${attribute}="${CSS.escape(handle)}"]`);
      };

      function updateBracket() {
        rafId = null;

        const bracket = header.querySelector(selector);
        if (!(bracket instanceof SVGSVGElement)) return;

        header.dataset.twoLineBracketReduceMotion = reducedMotionQuery.matches ? 'true' : 'false';

        if (!desktopQuery.matches) {
          hideBracket();
          return;
        }

        const handle = getActiveHandle();
        const parentScope = header.querySelector('.header-menu--two-line') || header;
        const childScope = header.querySelector('.header__navigation-bar-row') || header;
        const parent = queryByHandle(parentScope, 'data-two-line-parent', handle);
        const childNav = queryByHandle(childScope, 'data-two-line-child-nav', handle);
        const childList = childNav?.querySelector('[data-two-line-child-list]');
        const childScroll = childNav?.querySelector('.two-line-menu__scroll');
        const sourcePath = bracket.querySelector('[data-two-line-bracket-source]');
        const framePath = bracket.querySelector('[data-two-line-bracket-frame]');

        if (
          !(parent instanceof HTMLElement) ||
          !(childNav instanceof HTMLElement) ||
          !(childList instanceof HTMLElement) ||
          !(childScroll instanceof HTMLElement) ||
          !(sourcePath instanceof SVGPathElement) ||
          !(framePath instanceof SVGPathElement) ||
          parent.dataset.twoLineHasChildren !== 'true'
        ) {
          hideBracket();
          return;
        }

        const headerRect = header.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const childNavRect = childNav.getBoundingClientRect();
        const childScrollRect = childScroll.getBoundingClientRect();
        const listWidth = childList.scrollWidth;
        const parentCenter = parentRect.left + parentRect.width / 2;
        const maxOffset = Math.max(0, childScroll.clientWidth - listWidth);
        const childOffset = Math.max(0, Math.min(parentCenter - childScrollRect.left - listWidth / 2, maxOffset));

        childNav.style.setProperty('--two-line-child-offset', `${Math.round(childOffset)}px`);

        const parentLeft = Math.round(parentRect.left - headerRect.left + 2);
        const parentRight = Math.round(parentRect.right - headerRect.left - 2);
        const underlineY = Math.round(parentRect.bottom - headerRect.top - 1);
        const childLeft = Math.round(childScrollRect.left - headerRect.left + childOffset);
        const childRight = Math.round(childLeft + listWidth);
        const railY = Math.round(childNavRect.top - headerRect.top + 12);
        const dropY = Math.round(Math.min(childNavRect.bottom - headerRect.top - 5, railY + 17));
        const shoulder = 10;
        const corner = 6;

        bracket.setAttribute('width', `${Math.round(headerRect.width)}`);
        bracket.setAttribute('height', `${Math.round(headerRect.height)}`);
        bracket.setAttribute('viewBox', `0 0 ${Math.round(headerRect.width)} ${Math.round(headerRect.height)}`);

        animatePath(sourcePath, `M ${parentLeft} ${underlineY} L ${parentRight} ${underlineY}`);
        animatePath(
          framePath,
          [
            `M ${childLeft} ${dropY}`,
            `L ${childLeft} ${railY + corner}`,
            `Q ${childLeft} ${railY} ${childLeft + corner} ${railY}`,
            `L ${parentLeft - shoulder} ${railY}`,
            `Q ${parentLeft - 3} ${railY} ${parentLeft} ${underlineY + 3}`,
            `L ${parentRight} ${underlineY + 3}`,
            `Q ${parentRight + 3} ${railY} ${parentRight + shoulder} ${railY}`,
            `L ${childRight - corner} ${railY}`,
            `Q ${childRight} ${railY} ${childRight} ${railY + corner}`,
            `L ${childRight} ${dropY}`,
          ].join(' ')
        );

        header.dataset.twoLineBracketReady = 'true';
      }

      window.addEventListener('resize', () => scheduleUpdate());
      desktopQuery.addEventListener('change', () => scheduleUpdate());
      reducedMotionQuery.addEventListener('change', () => scheduleUpdate());

      const resizeObserver = new ResizeObserver(() => scheduleUpdate());
      resizeObserver.observe(header);
      for (const element of header.querySelectorAll('[data-two-line-parent], [data-two-line-child-list]')) {
        if (element instanceof HTMLElement) resizeObserver.observe(element);
      }

      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 150);
      window.setTimeout(scheduleUpdate, 600);
      window.setTimeout(scheduleUpdate, 1400);
    };

    const boot = () => {
      for (const header of document.querySelectorAll('header-component')) {
        init(header);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
